import { CodeBase } from "./_codeBase";

/** 挿入先セル*/
export class InsertCellDiv extends CodeBase<InsertCellDiv>
{
    /** 挿入先セル区分: "01", "機器", ""*/
    public static readonly EQUIPMENT: InsertCellDiv = new InsertCellDiv("01", "機器", "");
    /** 挿入先セル区分: "02", "機器付帯項目" ""*/
    public static readonly INCIDENTAL: InsertCellDiv = new InsertCellDiv("02", "機器付帯項目", "");
    /** 挿入先セル区分: "03", "立会作業", ""*/
    public static readonly ATTENDANT: InsertCellDiv = new InsertCellDiv("03", "立会作業", "");
    /** 挿入先セル区分: "04", "作業 ""*/
    public static readonly WORK: InsertCellDiv = new InsertCellDiv("04", "作業", "");
    /** 挿入先セル区分: "05", "進捗 ""*/
    public static readonly PROGRESS: InsertCellDiv = new InsertCellDiv("05", "進捗", "");


    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): InsertCellDiv[] {
        return [
            InsertCellDiv.EQUIPMENT,
            InsertCellDiv.INCIDENTAL,
            InsertCellDiv.ATTENDANT,
            InsertCellDiv.WORK,
            InsertCellDiv.PROGRESS,
        ];
    }
}